import type { z } from 'zod';
import { queryOptions } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoMarcaSchema } from '../types/ProdutoMarca';

export type ApiProdutoMarcaGetParams = DefaultApiParams & {
    pesquisar?: string;
};

type ApiProdutoMarcaGetProps<Schema extends z.ZodType> = {
    idpk?: number;
    params?: ApiProdutoMarcaGetParams;
    schema?: Schema;
};

const defaultSchema = registrosSchema(ProdutoMarcaSchema);

function apiProdutoMarcaGet<Schema extends z.ZodType = typeof defaultSchema>({
    idpk,
    params,
    schema,
}: ApiProdutoMarcaGetProps<Schema>): Promise<z.infer<Schema>> {
    return fetchApi({
        endpoint: 'Produto/Marca',
        idpk,
        method: 'get',
        params,
        schema: schema ?? defaultSchema,
    }) as Promise<z.infer<Schema>>;
}

export const API_PRODUTO_MARCA_GET_KEY = 'apiProdutoMarcaGet';

export function apiProdutoMarcaGetQueryOptions<Schema extends z.ZodType = typeof defaultSchema>(
    props: ApiProdutoMarcaGetProps<Schema>,
) {
    return queryOptions({
        queryFn: () => apiProdutoMarcaGet(props),
        queryKey: [API_PRODUTO_MARCA_GET_KEY, props],
    });
}
